import { ArrowRight, Zap, Shield, TrendingUp, Users, CreditCard, Smartphone, Globe, Menu, X } from 'react-feather';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import ThemeToggle from '../components/ThemeToggle';
import BrandWordmark from '../components/BrandWordmark';
import AdsDisplay from '../components/AdsDisplay';
import { getServiceColor, getServiceIconAsset } from '../utils/serviceIcons';
import '../styles/Landing.css';

export default function Landing() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <>
      {/* Mobile Sidebar */}
      <aside className={`landing-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <BrandWordmark className="landing-brand-mark" forceLightLogo />
        </div>

        <nav className="sidebar-nav">
          <a href="#features" className="sidebar-link" onClick={() => setSidebarOpen(false)}>Features</a>
          <a href="#how-it-works" className="sidebar-link" onClick={() => setSidebarOpen(false)}>How It Works</a>
          <a href="#pricing" className="sidebar-link" onClick={() => setSidebarOpen(false)}>Pricing</a>
        </nav>

        <div className="sidebar-theme-toggle">
          <ThemeToggle />
        </div>

        <div className="sidebar-buttons">
          <Link to="/login" className="sidebar-login" onClick={() => setSidebarOpen(false)}>Login</Link>
          <Link to="/register" className="sidebar-signup" onClick={() => setSidebarOpen(false)}>Sign Up</Link>
        </div>
      </aside>

      {/* Sidebar Backdrop */}
      {sidebarOpen && <div className="landing-sidebar-backdrop" onClick={() => setSidebarOpen(false)} />}

      <div className="landing">
      {/* Navigation */}
      <nav className="landing-nav">
        <div className="nav-container">
          <div className="logo">
            <BrandWordmark className="landing-brand-mark" forceLightLogo />
          </div>
          <div className="nav-links">
            <a href="#features" className="nav-link">Features</a>
            <a href="#how-it-works" className="nav-link">How It Works</a>
            <a href="#pricing" className="nav-link">Pricing</a>
            <div className="nav-theme-toggle">
              <ThemeToggle />
            </div>
            <Link to="/login" className="nav-link nav-login">Login</Link>
            <Link to="/register" className="nav-link nav-signup">Sign Up</Link>
          </div>
          <button 
            className="menu-toggle" 
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label="Toggle menu"
          >
            {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">
            Boost Your Social Media Presence
          </h1>
          <p className="hero-subtitle">
            The easiest way to grow followers, likes, and engagement across all platforms
          </p>
          <div className="hero-buttons">
            <Link to="/register" className="btn btn-primary btn-lg">
              Get Started Free
              <ArrowRight size={18} style={{ marginLeft: 8 }} />
            </Link>
            <Link to="/login" className="btn btn-secondary btn-lg landing-signin-btn">
              Sign In
            </Link>
          </div>
          <p className="hero-note"><Zap size={16} style={{ display: 'inline', marginRight: 8 }} />No credit card required • Fast setup • 24/7 support</p>
        </div>
        <div className="hero-image">
          <div className="hero-graphic">
            <div className="graphic-element graphic-1"></div>
            <div className="graphic-element graphic-2"></div>
            <div className="graphic-element graphic-3"></div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features">
        <div className="section-header">
          <h2>Why Choose NiceBooster?</h2>
          <p>Everything you need to grow on social media, all in one place</p>
        </div>

        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <Zap size={32} />
            </div>
            <h3>Instant Delivery</h3>
            <p>Orders are processed immediately. See results within minutes, not days</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <Shield size={32} />
            </div>
            <h3>100% Safe & Secure</h3>
            <p>Your account and payments are protected with enterprise-grade security</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <TrendingUp size={32} />
            </div>
            <h3>Real Growth</h3>
            <p>High-quality followers and engagement that boost your algorithm ranking</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <CreditCard size={32} />
            </div>
            <h3>Multiple Payment Methods</h3>
            <p>Pay with mobile money, cryptocurrency, or other convenient payment options</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <Smartphone size={32} />
            </div>
            <h3>Mobile Friendly</h3>
            <p>Manage your orders on the go with our fully responsive mobile app</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <Users size={32} />
            </div>
            <h3>24/7 Customer Support</h3>
            <p>Get help anytime with our responsive support team via chat and email</p>
          </div>
        </div>
      </section>

      {/* Ad 1 - After Features */}
      <AdsDisplay adSlot="banner-728x90" className="banner" />

      {/* How It Works Section */}
      <section id="how-it-works" className="how-it-works">
        <div className="section-header">
          <h2>How It Works</h2>
          <p>Get started in 3 simple steps</p>
        </div>

        <div className="steps">
          <div className="step">
            <div className="step-number">1</div>
            <h3>Create Account</h3>
            <p>Sign up for free in less than 60 seconds. No credit card needed upfront</p>
          </div>

          <div className="step-arrow">
            <ArrowRight size={24} />
          </div>

          <div className="step">
            <div className="step-number">2</div>
            <h3>Add Funds</h3>
            <p>Deposit money using your preferred payment method. Instant confirmation</p>
          </div>

          <div className="step-arrow">
            <ArrowRight size={24} />
          </div>

          <div className="step">
            <div className="step-number">3</div>
            <h3>Place Orders</h3>
            <p>Browse services, select quantity, and place orders. Instant processing</p>
          </div>
        </div>
      </section>

      {/* Ad 2 - After How It Works */}
      <AdsDisplay adSlot="banner-300x250" className="medium-rectangle" />

      {/* Ad 3 - Before Supported Platforms */}
      <AdsDisplay adSlot="native-banner" className="native-banner" />

      {/* Supported Platforms Section */}
      <section className="platforms">
        <div className="section-header">
          <h2>Services for All Platforms</h2>
          <p>Grow on your favorite social networks</p>
        </div>

        <div className="platforms-grid">
          {[
            { name: 'Instagram', key: 'instagram' },
            { name: 'TikTok', key: 'tiktok' },
            { name: 'YouTube', key: 'youtube' },
            { name: 'Facebook', key: 'facebook' },
            { name: 'Telegram', key: 'telegram' },
          ].map((platform) => {
            const iconAsset = getServiceIconAsset(platform.key);
            const color = getServiceColor(platform.key);
            const isTiktok = platform.key === 'tiktok';

            return (
              <div key={platform.key} className={`platform platform-${platform.key}`}>
                <div
                  className="platform-icon"
                  style={{
                    background: isTiktok
                      ? 'linear-gradient(135deg, #0f172a 0%, #111827 100%)'
                      : `${color}16`,
                    borderColor: isTiktok ? 'rgba(15, 23, 42, 0.55)' : `${color}33`,
                    color
                  }}
                >
                  {iconAsset && (
                    <img
                      src={iconAsset}
                      alt={platform.name}
                      style={{
                        width: 28,
                        height: 28,
                        filter: isTiktok ? 'drop-shadow(0 2px 10px rgba(34,211,238,0.3))' : 'none'
                      }}
                    />
                  )}
                </div>
                <span>{platform.name}</span>
              </div>
            );
          })}
        </div>
      </section>

      <section className="landing-guides">
        <div className="section-header">
          <h2>Growth Guides</h2>
          <p>Helpful pages built for real users searching for social media growth answers</p>
        </div>

        <div className="landing-guides-grid">
          {[
            {
              title: 'Buy Instagram Followers in Africa',
              text: 'Understand follower quality, refill types, and how to pair followers with real engagement.',
              to: '/guides/instagram-followers',
              key: 'instagram',
            },
            {
              title: 'Buy TikTok Views and Engagement',
              text: 'Learn when views help, when they do not, and how to balance them with likes and profile growth.',
              to: '/guides/tiktok-views',
              key: 'tiktok',
            },
            {
              title: 'Buy Telegram Members',
              text: 'See how channel members, views, and reactions work together for stronger Telegram growth.',
              to: '/guides/telegram-members',
              key: 'telegram',
            },
            {
              title: 'Website Traffic Explained',
              text: 'Read the difference between website traffic, SEO traffic, and social traffic services.',
              to: '/guides/website-traffic-explained',
              key: 'website',
            },
          ].map((guide) => {
            const iconAsset = getServiceIconAsset(guide.key);
            const color = getServiceColor(guide.key);
            const isTiktokGuide = guide.key === 'tiktok';

            return (
            <Link key={guide.to} to={guide.to} className={`landing-guide-card landing-guide-card-${guide.key}`}>
              <div
                className="landing-guide-icon"
                style={{
                  background: isTiktokGuide
                    ? 'linear-gradient(135deg, #0f172a 0%, #111827 100%)'
                    : `${color}12`,
                  borderColor: isTiktokGuide ? 'rgba(15, 23, 42, 0.55)' : `${color}26`,
                  color,
                }}
              >
                {iconAsset && (
                  <img
                    src={iconAsset}
                    alt=""
                    className="landing-guide-icon-image"
                    style={{
                      filter: isTiktokGuide ? 'drop-shadow(0 2px 10px rgba(34,211,238,0.28))' : 'none',
                    }}
                  />
                )}
              </div>
              <h3>{guide.title}</h3>
              <p>{guide.text}</p>
              <span>Read guide</span>
            </Link>
          );
          })}
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="pricing">
        <div className="section-header">
          <h2>Competitive Pricing</h2>
          <p>Best rates in the industry</p>
        </div>

        <div className="pricing-info">
          {[
            {
              title: 'Instagram Followers',
              price: 'Starting from $2.99',
              desc: 'High-quality followers',
              tone: 'pricing-card-navy',
              label: 'Best Seller',
            },
            {
              title: 'YouTube Views',
              price: 'Starting from $1.99',
              desc: 'Real, authentic views',
              tone: 'pricing-card-navy',
              label: 'Creator Value',
            },
            {
              title: 'TikTok Engagement',
              price: 'Starting from $3.49',
              desc: 'Boost your reach',
              tone: 'pricing-card-navy',
              label: 'Fast Momentum',
            },
          ].map((item) => (
            <div key={item.title} className={`pricing-card ${item.tone}`}>
              <span className="pricing-card-label">{item.label}</span>
              <h3>{item.title}</h3>
              <p className="price">{item.price}</p>
              <p className="desc">{item.desc}</p>
            </div>
          ))}
        </div>

        <p className="pricing-note"><CreditCard size={18} style={{ display: 'inline', marginRight: 8 }} />Sign up today and get 10% bonus on your first deposit!</p>
      </section>

      {/* Ad 4 - After Pricing */}
      <AdsDisplay adSlot="banner-320x50" className="banner" />

      {/* CTA Section */}
      <section className="cta">
        <div className="cta-content">
          <h2>Ready to Grow Your Social Media?</h2>
          <p>Join thousands of content creators and influencers using NiceBooster</p>
          <div className="cta-buttons">
            <Link to="/register" className="btn btn-primary btn-lg">
              Start Free Trial
            </Link>
            <a href="#features" className="btn btn-secondary btn-lg">
              Learn More
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>NiceBooster</h4>
            <p>The ultimate SMM panel for growing your social media presence</p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/login">Login</Link></li>
              <li><Link to="/register">Sign Up</Link></li>
              <li><a href="#features">Features</a></li>
              <li><a href="#pricing">Pricing</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Support</h4>
            <ul>
              <li><a href="mailto:support@nicebooster.site">Email Support</a></li>
              <li><a href="https://wa.me/237688656076" target="_blank" rel="noopener noreferrer">WhatsApp</a></li>
              <li><a href="#features">FAQ</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/terms-of-service">Terms of Service</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 NiceBooster. All rights reserved.</p>
        </div>
      </footer>
      </div>
    </>
  );
}
